export const CONTROL_CENTER_REFRESH_LOADING = "CONTROL_CENTER_REFRESH_LOAD";

export function actionControlCenterRefreshLoading(data) {
    return { type: CONTROL_CENTER_REFRESH_LOADING, data };
}